import React from 'react';
import { CalendarDaysIcon, ClipboardListIcon, FlameIcon, MailIcon, PresentationIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/content';
const icons = {
  presentation: PresentationIcon,
  'clipboard-list': ClipboardListIcon,
  flame: FlameIcon,
  mail: MailIcon,
  calendar: CalendarDaysIcon
};
export function Bonuses() {
  return <section className="w-full bg-navy px-5 py-20 sm:px-8" data-id="element-39" data-mp="1tvlzg1xe6ql">
      <div className="mx-auto w-full max-w-5xl" data-id="element-40" data-mp="1whtjfotgm8t">
        <div className="mx-auto max-w-2xl text-center" data-id="element-41" data-mp="5w8nfs9n3ihk">
          <Reveal data-id="element-42" data-mp="5tnlz4d974kc">
            <p className="inline-block rounded-full bg-gold px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.16em] text-navy" data-id="element-43" data-mp="3o1v6kim4xyqq">
              Ingår gratis idag
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-44" data-mp="1m9qiji7rblla">
            <h2 className="mt-6 text-3xl font-extrabold leading-tight tracking-tight text-cream sm:text-4xl" data-id="element-45" data-mp="1mbjpkyma87tt">
              5 exklusiva bonusar — helt utan extra kostnad
            </h2>
          </Reveal>

          <Reveal delay={0.12} data-id="element-46" data-mp="3icvcld4e8m2g">
            <p className="mt-5 text-base leading-relaxed text-cream/70" data-id="element-47" data-mp="3ic3i65mj8udr">
              Du får inte bara de 10 kompletta volymerna. Idag ingår även fem praktiska
              extramaterial som hjälper dig att planera, undervisa och följa utvecklingen
              — helt gratis.
            </p>
          </Reveal>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-48" data-mp="2zf2aue5iai6n">
          {bonuses.map((bonus, index) => {
          const Icon = icons[bonus.icon as keyof typeof icons];
          const isLast = index === bonuses.length - 1;
          return <Reveal as="li" key={bonus.number} delay={index % 2 * 0.06} className={isLast ? 'md:col-span-2 md:mx-auto md:w-full md:max-w-lg' : ''} data-id="element-49" data-mp="38hjz0y4q1kwa" data-mpi={index}>
                <div className="flex h-full flex-col rounded-2xl border border-cream/12 bg-white/[0.04] p-6" data-id="element-50" data-mp="iqygo8nkweyp">
                  <div className="flex items-start justify-between gap-4" data-id="element-51" data-mp="3cj6fm8uevimq">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gold/15" data-id="element-52" data-mp="3cl94gpjtv5pv">
                      <Icon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-53" data-mp="3ljul2f5qoao0" />
                    </span>
                    <span className="rounded-full bg-level-green px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-54" data-mp="3qifmghwq90e1">
                      Gratis idag
                    </span>
                  </div>

                  <p className="mt-5 text-[10px] font-extrabold uppercase tracking-[0.18em] text-gold" data-id="element-55" data-mp="2xv1xb5z9t94h">
                    {bonus.number}
                  </p>
                  <h3 className="mt-2 text-base font-extrabold leading-snug text-cream" data-id="element-56" data-mp="37jto3aslhndt">
                    {bonus.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-cream/65" data-id="element-57" data-mp="2a3o6j4grpllm">
                    {bonus.description}
                  </p>

                  <p className="mt-auto pt-5 text-[11px] font-bold uppercase tracking-[0.14em] text-cream/50 line-through" data-id="element-58" data-mp="2f165c212mkfw">
                    {bonus.value}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>

        <Reveal delay={0.12} data-id="element-59" data-mp="1xkiouzsj79b7">
          <p className="mt-12 text-center text-sm font-semibold uppercase tracking-[0.14em] text-cream/70" data-id="element-60" data-mp="1xnwqu6xa9gi4">
            Samlat värde för de 5 bonusarna:{' '}
            <span className="font-serif text-2xl normal-case tracking-normal text-gold" data-id="element-61" data-mp="1om7073b86lle">
              1 205 kr
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}